import React from 'react';
import { BookOpen, FileText, Search, Shield, Zap } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: BookOpen,
    title: 'El Manual Maestro "Guía de Crédito 700+"',
    desc: 'Ebook PDF completo con toda la estrategia.'
  }, {
    icon: Zap,
    title: 'El Protocolo 72h',
    desc: 'Instrucciones exactas para enviar tu primera ráfaga de disputas.'
  }, {
    icon: Search,
    title: 'Guía de Auditoría Extrema',
    desc: 'Para encontrar los 5 errores que el 80% de los hispanos tiene en su reporte.'
  }, {
    icon: FileText,
    title: 'El Secreto del "Método de Verificación"',
    desc: 'Para cuando el buró intenta decirte que no puede borrar una cuenta.'
  }, {
    icon: Shield,
    title: 'Plan de Blindaje de Identidad',
    desc: 'Para que nunca vuelvan a ensuciar tu crédito.'
  }];
  return <section className="bg-navy-900 px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-201">
      <div className="mx-auto max-w-5xl" data-id="element-202">
        <div className="mb-16 text-center" data-id="element-203">
          <h2 className="mb-6 text-4xl sm:text-5xl font-bebas text-white" data-id="element-204">
            Lo Que Recibes <span className="text-gold-400" data-id="element-205">Hoy</span>
          </h2>
        </div>

        <div className="grid gap-8 lg:grid-cols-2 lg:items-center" data-id="element-206">
          <div className="order-2 lg:order-1 space-y-6" data-id="element-207">
            {items.map((item, index) => <div key={index} className="flex gap-4 rounded-xl bg-navy-800 p-5 border border-slate-700/50 hover:border-gold-500/30 transition-colors" data-id="element-208">
                <div className="flex-shrink-0 mt-1" data-id="element-209">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gold-500/10" data-id="element-210">
                    <item.icon className="h-5 w-5 text-gold-400" data-id="element-211" />
                  </div>
                </div>
                <div data-id="element-212">
                  <h3 className="text-lg font-bold text-white mb-1" data-id="element-213">
                    {item.title}
                  </h3>
                  <p className="text-slate-400" data-id="element-214">{item.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="order-1 lg:order-2 flex justify-center" data-id="element-215">
            <div className="relative" data-id="element-216">
              <div className="absolute -inset-4 rounded-full bg-gold-500/20 blur-3xl" data-id="element-217"></div>
              <img src="https://cdn.magicpatterns.com/uploads/meMnx1rVy2wfikc36UUxhS/IMAGE-GUIA_DE_CREDITO_7002B_EL_METODO_72H.png" alt="Contenido del producto" className="relative z-10 w-full max-w-sm drop-shadow-2xl" data-id="element-218" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}